import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import {
  withOverridableStyles,
} from '@bingads-webui-campaign-react/ads-studio-shared-components';
import { getImageShimmerStyles } from './style';

const ImageShimmerImpl = ({ className, classes }) => (
  <div className={classNames(classes.imageShimmerRoot, className)} />
);

ImageShimmerImpl.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}).isRequired,
};

ImageShimmerImpl.defaultProps = {
  className: undefined,
};

export const ImageShimmer = withOverridableStyles(ImageShimmerImpl, getImageShimmerStyles);
